import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

// IMPORT PACKAGE REFERENCES

import { sortDevices } from '../State/Actions/DeviceActions';
import { FilterType } from './FilterType';
import { SortType } from './SortType';
import { DirectionType } from './DirectionType';


// COMPONENT

class DeviceSidebar extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            searchText: '',
            activeSort: SortType.ALPHABETICALLY,
            activeDirection: DirectionType.ASCENDING,
            activeFilter: FilterType.ALL,
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ activeSort: nextProps.activeSort, activeDirection: nextProps.activeDirection, activeFilter: nextProps.activeFilter })
    }


    sortClicked(sortType) {
        this.props.sortDevices(sortType, this.state.activeDirection);
    }

    directionClicked(directionType) {
        this.props.sortDevices(this.state.activeSort, directionType);
    }

    render() {
        return (
            <div className="sidebar">
                <div className="sidebar-section-header">Sort Devices</div>
                <div className={"sidebar-section-option " + ((this.state.activeSort === SortType.ALPHABETICALLY) && "active") } onClick={() => this.sortClicked(SortType.ALPHABETICALLY)} >Alphabetically</div>
                <div className={"sidebar-section-option " + ((this.state.activeSort === SortType.BATTERY_PERCENT) && "active") } onClick={() => this.sortClicked(SortType.BATTERY_PERCENT)} >Battery</div>

                <div className="sidebar-section-header">Sort Direction</div>
                <div className={"sidebar-section-option " + ((this.state.activeDirection === DirectionType.ASCENDING) && "active") } onClick={() => this.directionClicked(DirectionType.ASCENDING)} >Ascending</div>
                <div className={"sidebar-section-option " + ((this.state.activeDirection === DirectionType.DESCENDING) && "active") } onClick={() => this.directionClicked(DirectionType.DESCENDING)} >Descending</div>
                
            </div>
        )
    }
}


// CONFIGURE REACT REDUX
const mapStateToProps = state => {
  const { activeFilter, activeSort, activeDirection } = state.devicesReducer;
  return { activeFilter, activeSort, activeDirection };
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({ sortDevices }, dispatch)
);

const hoc = connect(mapStateToProps, mapDispatchToProps)(DeviceSidebar);


// EXPORT COMPONENT

export { hoc as DeviceSidebar };